/* eslint-disable babel/camelcase */
import { StyleSheet } from '@rexlabs/styling';
export default StyleSheet({
  showButton: {
    appearance: 'none',
    backgroundColor: 'transparent',
    border: 0,
    color: 'inherit',
    font: 'inherit',
    overflow: 'visible',
    padding: 0,
    cursor: 'pointer',
    width: 22,
    position: 'absolute',
    zIndex: 3,
    ':active': {
      outline: 'none'
    }
  },
  closeButton: {
    appearance: 'none',
    backgroundColor: 'transparent',
    border: 0,
    color: 'inherit',
    font: 'inherit',
    overflow: 'visible',
    padding: 0,
    cursor: 'pointer',
    position: 'absolute',
    right: 22,
    top: 22,
    zIndex: 3,
    ':active': {
      outline: 'none'
    }
  },
  topLeft: {
    borderStyle: 'solid',
    borderBottomWidth: 26,
    borderBottomColor: 'transparent',
    borderLeftWidth: 33,
    borderLeftColor: 'turquoise',
    top: 0,
    left: 0,
    ':hover': {
      borderLeftColor: 'darkturquoise'
    }
  },
  topRight: {
    borderStyle: 'solid',
    borderBottomWidth: 26,
    borderBottomColor: 'transparent',
    borderRightWidth: 33,
    borderRightColor: 'turquoise',
    top: 0,
    right: 0,
    ':hover': {
      borderRightColor: 'darkturquoise'
    }
  },
  bottomRight: {
    borderStyle: 'solid',
    borderTopWidth: 26,
    borderTopColor: 'transparent',
    borderRightWidth: 33,
    borderRightColor: 'turquoise',
    bottom: 0,
    right: 0,
    ':hover': {
      borderRightColor: 'darkturquoise'
    }
  },
  showButtonLabel: {
    position: 'absolute',
    color: 'white',
    fontSize: '0.9em',
    fontWeight: 900
  },
  showButtonLabel_topLeft: {
    top: 0,
    left: -28
  },
  showButtonLabel_topRight: {
    top: 0,
    right: -28
  },
  showButtonLabel_bottomRight: {
    bottom: 0,
    right: -28
  },
  panel: {
    overflow: 'auto',
    background: 'white',
    border: '1px solid whitesmoke',
    borderRadius: 2,
    position: 'absolute',
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
    zIndex: 3,
    padding: 22,
    margin: 33
  },
  block: {},
  title: {
    fontSize: '16px',
    fontWeight: '900',
    margin: 0
  },
  list: {
    listStyle: 'none',
    padding: 0
  },
  row: {
    margin: '6px 0'
  },
  row_block: {
    marginBottom: 16
  },
  keys: {
    display: 'inline-block',
    whiteSpace: 'nowrap',
    textAlign: 'right',
    marginRight: 6
  },
  keys_block: {
    width: 'auto',
    textAlign: 'left',
    display: 'inline'
  },
  key: {
    fontFamily: 'monospace',
    fontSize: '12px',
    textTransform: 'uppercase',
    backgroundColor: 'whitesmoke',
    padding: '2px 6px'
  },
  action: {
    display: 'inline',
    wordBreak: 'break-word',
    marginLeft: 8,
    fontSize: '0.9em'
  }
});